import numeral from 'numeral';
import React, { useEffect, useState } from 'react'

export const NotificacionesMoneda = (params) => {

    //#region internalState
    const [internalState, setInternalState] = useState({
        Load: false,
        MonedaDetalle: params.MonedaDetalle,
        Orders: {
            bids: [],
            asks: [],
        },
    })
    //#endregion
    //#region useEffect
    useEffect(() => { return Load(); }, []);
    //#endregion
    //#region Metodos
    const Load = async () => {
        // debugger
        console.log(internalState.MonedaDetalle)
        let websocket = new WebSocket('wss://ws.bitso.com');
        websocket.onopen = function () {
            let book = `${internalState.MonedaDetalle.Item.Clave}_mxn`;
            // websocket.send(JSON.stringify({ action: 'subscribe', book, type: 'trades' }));
            // websocket.send(JSON.stringify({ action: 'subscribe', book, type: 'diff-orders' }));
            websocket.send(JSON.stringify({ action: 'subscribe', book, type: 'orders' }));
        };
        websocket.onmessage = function (message) {
            var data = JSON.parse(message.data);
            if (data.type === 'trades' && data.payload) {

            } else if (data.type === 'diff-orders' && data.payload) {

            } else if (data.type === 'orders' && data.payload) {
                setInternalState((state) => ({ ...state, Orders: data.payload }));
            }
            console.log(data);
        };
        return () => {
            websocket = null;
        }
    }
    //#endregion

    return (<>
        <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "49%" }}>
                <div>Posturas de Compra</div>
                {
                    internalState.Orders.bids.map((item) => {

                        return (<>
                            <div style={{ display: "flex" }}>
                                <div style={{ marginRight: "5px" }}>$ {numeral(item.r).format("0,000.00")}</div>
                                <div style={{ marginRight: "5px" }}> * {numeral(item.a).format("0,000.00000000")}</div>
                                <div style={{ marginRight: "5px" }}> = {numeral(item.v).format("0,000.00")}</div>
                            </div>
                        </>)
                    })
                }
            </div>
            <div style={{ width: "49%" }}>
                <div>Posturas de Venta</div>
                {
                    internalState.Orders.asks.map((item) => {

                        return (<>
                            <div style={{ display: "flex" }}>
                                <div style={{ marginRight: "5px" }}>$ {numeral(item.r).format("0,000.00")}</div>
                                <div style={{ marginRight: "5px" }}> * {numeral(item.a).format("0,000.00000000")}</div>
                                <div style={{ marginRight: "5px" }}> = {numeral(item.v).format("0,000.00")}</div>
                            </div>
                        </>)
                    })
                }
            </div>
        </div>

    </>)
}
